// Negociacao da venda atribuida ao vendedor (#1517). Mesmas regras da API.

export const CANAIS_CONTATO = [
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'chat_site', label: 'Chat do site' },
    { value: 'telefone', label: 'Telefone' },
    { value: 'pergunta_ml', label: 'Pergunta ML' },
    { value: 'email', label: 'E-mail' },
    { value: 'presencial', label: 'Presencial' },
    { value: 'outro', label: 'Outro' },
];

export const NEGOCIACAO_VAZIA = {
    canal_contato: '',
    canal_contato_outro: '',
    cliente_nome: '',
    cliente_telefone: '',
    data_negociacao: '',
    cupom: '',
    desconto_tipo: '',
    desconto_valor: '',
};

const digitos = (v) => String(v || '').replace(/\D+/g, '');

export const mascaraTelefone = (valor) => {
    const d = digitos(valor).slice(0, 11);
    if (d.length <= 2) return d ? `(${d}` : '';
    if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
    if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

// Telefone do cadastro do cliente para pre-preencher: tira o 55 do Brasil se vier junto.
export const telefoneDoCadastro = (valor) => {
    let d = digitos(valor);
    if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2);
    return d.length >= 10 && d.length <= 11 ? mascaraTelefone(d) : '';
};

// Aceita "12,5", "12.50", "1.234,56".
export const lerNumero = (valor) => {
    const s = String(valor ?? '').trim();
    if (s === '') return null;
    const normal = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
    return /^\d+(\.\d+)?$/.test(normal) ? Number(normal) : NaN;
};

const hoje = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const daApi = (n) => ({
    ...NEGOCIACAO_VAZIA,
    ...Object.fromEntries(Object.keys(NEGOCIACAO_VAZIA).map((k) => [k, n?.[k] ?? ''])),
    cliente_telefone: n?.cliente_telefone ? mascaraTelefone(n.cliente_telefone) : '',
    desconto_valor: n?.desconto_valor != null ? String(n.desconto_valor).replace('.', ',') : '',
});

/** Primeiro erro do formulario, ou null. */
export const validarNegociacao = (dados, { canalObrigatorio = false } = {}) => {
    if (canalObrigatorio && !dados.canal_contato) return 'Informe o canal de contato da negociação.';
    if (dados.canal_contato === 'outro' && !String(dados.canal_contato_outro || '').trim()) return 'Descreva o canal de contato.';
    const tel = digitos(dados.cliente_telefone);
    if (tel && (tel.length < 10 || tel.length > 13)) return 'Telefone deve ter DDD e número (10 a 13 dígitos).';
    if (dados.data_negociacao && dados.data_negociacao > hoje()) return 'A data da negociação não pode ser futura.';
    const valor = lerNumero(dados.desconto_valor);
    if (Number.isNaN(valor)) return 'Desconto inválido.';
    if (valor !== null && !dados.desconto_tipo) return 'Informe se o desconto é em R$ ou em %.';
    if (dados.desconto_tipo && valor === null) return 'Informe o valor do desconto.';
    if (valor !== null && valor <= 0) return 'O desconto precisa ser maior que zero.';
    if (dados.desconto_tipo === 'percentual' && valor > 100) return 'Desconto em % não pode passar de 100.';
    return null;
};

export const paraApi = (dados) => {
    const valor = lerNumero(dados.desconto_valor);
    return {
        canal_contato: dados.canal_contato || null,
        canal_contato_outro: dados.canal_contato === 'outro' ? String(dados.canal_contato_outro || '').trim() || null : null,
        cliente_nome: String(dados.cliente_nome || '').trim() || null,
        cliente_telefone: digitos(dados.cliente_telefone) || null,
        data_negociacao: dados.data_negociacao || null,
        cupom: String(dados.cupom || '').trim() || null,
        desconto_tipo: valor !== null ? dados.desconto_tipo || null : null,
        desconto_valor: valor !== null && !Number.isNaN(valor) ? valor.toFixed(2) : null,
    };
};

export const temNegociacao = (dados) => Object.values(paraApi(dados)).some((v) => v !== null);

export const textoDesconto = (n) => {
    if (n?.desconto_valor == null) return null;
    const valor = Number(n.desconto_valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return n.desconto_tipo === 'percentual' ? `${valor.replace(/,00$/, '')}%` : `R$ ${valor}`;
};
